export const backNavigation = (pathname: string, categoryCount: number) => {
  if (
    pathname === '/play/campaigns' ||
    pathname === '/play/daily' ||
    pathname === '/play/endless' ||
    pathname === '/play/party' ||
    pathname === '/play/battles' ||
    pathname === '/play/collections'
  ) {
    return { to: '/play' as const, label: 'Назад к игровым режимам' };
  }
  if (/^\/play\/campaigns\/[^/]+\/?$/.test(pathname)) {
    return categoryCount === 1
      ? { to: '/play' as const, label: 'Назад к игровым режимам' }
      : { to: '/play/campaigns' as const, label: 'Назад к категориям' };
  }
  if (pathname.startsWith('/play/daily/')) {
    return { to: '/play/daily' as const, label: 'К категориям Daily' };
  }
  return null;
};
